<template>
  <div>
    <el-form ref="form" class="step2-form" :model="form" label-width="100px" v-if="showForm">
      <div class="props-items">
        <template v-for="ui in propsUI">
          <el-form-item v-if="ui.isShowFn ? ui.isShowFn(form) : true" :key="ui.name" :label="ui.label" :prop="ui.name" :rules="ui.rules">
            <component
              :ref="ui.name"
              :ui="ui"
              :is="ui.component.component"
              :props="ui.component.props"
              :value="form[ui.name]"
              @change="v => handleChange(ui.name, v)"
              :form="form"
            ></component>
          </el-form-item>
        </template>
      </div>
      <div class="others-items">
        <template v-for="ui in otherUI">
          <el-form-item v-if="ui.isShowFn ? ui.isShowFn(form) : true" :key="ui.name" :label="ui.label" :prop="ui.name" :rules="ui.rules">
            <component
              :ref="ui.name"
              :ui="ui"
              :is="ui.component.component"
              :props="ui.component.props"
              :value="form[ui.name]"
              @change="v => handleChange(ui.name, v)"
              :form="form"
            ></component>
          </el-form-item>
        </template>
      </div>
    </el-form>
  </div>
</template>

<script>
import { step2FormUI } from './ShelvesFlow/utils/ui';
import { step2Form2Data } from './ShelvesFlow/utils/data';
export default {
  props: ['schema', 'oriDatas'],
  data() {
    return {
      form: {},
      propsUI: [],
      otherUI: [],
      showForm: false,
    };
  },
  watch: {
    schema: {
      handler(schema) {
        // 规则变了，需要重新生成表单
        this.showForm = false;
        const [ui, form] = step2FormUI(schema, this.oriDatas[0]);
        this.propsUI = ui.props;

        // 平台返回的正则有误，'yyyy-MM-dd'并不能作为正则表达式解析，需要转化成真正的正则表达式
        ui.others.forEach(item => {
          if (item.label === '上市时间' && item.rules && item.rules.some(rule => rule.pattern == '/^yyyy-MM-dd$/')) {
            item.rules.forEach(rule => {
              if (rule.pattern == '/^yyyy-MM-dd$/') {
                rule.pattern = /^(\d{4})-(\d{2})-(\d{2})$/;
              }
            });
          }
        });

        this.otherUI = ui.others;
        this.form = form;
        this.showForm = true;
      },
      immediate: true,
    },
  },
  methods: {
    handleChange(name, v) {
      this.$set(this.form, name, v)
    },
    method_getData(noValid) {
      if(noValid) {
        return step2Form2Data(this.form, this.propsUI, this.otherUI);
      }
      return new Promise((resolve, reject) => {
        if (!this.$refs.form) {
          this.$message.error('商品类目天猫已废弃，本类目不能发布上商品，请重新选择类目');
          return false;
        }
        this.$nextTick(() => {
          this.$refs.form.validate(pass => {
            if (pass) {
              const data = step2Form2Data(this.form, this.propsUI, this.otherUI);
              resolve(data);
            } else {
              resolve(false);
            }
          });
        })
      });
    },  
    setForm(form) {
      this.form = form;
    }, 
    method_getStep2Form2Data() {
      const data = step2Form2Data(this.form, this.propsUI, this.otherUI);
      return
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  padding: 10px;
  background: #f8f8f8;
  font-weight: 600;
}
.props-items {
  // padding: 20px 10px;

  & ::v-deep .el-form-item {
    display: inline-block;
    width: 50%;
  }
  & ::v-deep .el-select {
    width: 100%;
  }
}
.step2-form {
  .others-items {
    & ::v-deep .complex-items {
      display: flex;
      flex-wrap: wrap;
    }
    & ::v-deep .complex-items .el-form-item.pic,
    & ::v-deep .cspuList .el-form-item,
    & ::v-deep .packList .el-form-item {
      margin-bottom: 10px !important;
      display: flex;
      flex-direction: column;
      align-items: center;
      .el-form-item__label {
        text-align: center;
      }
      .el-form-item__content {
        margin: 0 !important;
      }
    }
  }
}
</style>